import {
  StringSerializer_getInstance2wffkbpdux3h9 as StringSerializer_getInstance,
  BooleanSerializer_getInstance1t8habeqgiyq1 as BooleanSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance3hlj875zwihx0 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function MultiplexMessage$Companion$$childSerializers$_anonymous__okpt7() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), new (ArrayListSerializer())(StringSerializer_getInstance()));
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.j3j_1 = [null, null, lazy(tmp_0, MultiplexMessage$Companion$$childSerializers$_anonymous__okpt7), null, null, null, null];
      }
      m2a() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.websocket.MultiplexMessage', this, 7);
        tmp0_serialDesc.c1b('channel', false);
        tmp0_serialDesc.c1b('path', true);
        tmp0_serialDesc.c1b('queryParams', true);
        tmp0_serialDesc.c1b('start', true);
        tmp0_serialDesc.c1b('end', true);
        tmp0_serialDesc.c1b('data', true);
        tmp0_serialDesc.c1b('error', true);
        this.a4q_1 = tmp0_serialDesc;
      }
      b4q(encoder, value) {
        var tmp0_desc = this.a4q_1;
        var tmp1_output = encoder.l13(tmp0_desc);
        var tmp2_cached = Companion_getInstance().j3j_1;
        tmp1_output.a15(tmp0_desc, 0, value.c4q_1);
        if (tmp1_output.h15(tmp0_desc, 1) ? true : !(value.d4q_1 == null)) {
          tmp1_output.d15(tmp0_desc, 1, StringSerializer_getInstance(), value.d4q_1);
        }
        if (tmp1_output.h15(tmp0_desc, 2) ? true : !(value.e4q_1 == null)) {
          tmp1_output.d15(tmp0_desc, 2, tmp2_cached[2].f2(), value.e4q_1);
        }
        if (tmp1_output.h15(tmp0_desc, 3) ? true : !(value.f4q_1 === false)) {
          tmp1_output.s14(tmp0_desc, 3, value.f4q_1);
        }
        if (tmp1_output.h15(tmp0_desc, 4) ? true : !(value.g4q_1 === false)) {
          tmp1_output.s14(tmp0_desc, 4, value.g4q_1);
        }
        if (tmp1_output.h15(tmp0_desc, 5) ? true : !(value.h4q_1 == null)) {
          tmp1_output.d15(tmp0_desc, 5, StringSerializer_getInstance(), value.h4q_1);
        }
        if (tmp1_output.h15(tmp0_desc, 6) ? true : !(value.i4q_1 == null)) {
          tmp1_output.d15(tmp0_desc, 6, StringSerializer_getInstance(), value.i4q_1);
        }
        tmp1_output.m13(tmp0_desc);
      }
      oz(encoder, value) {
        return this.b4q(encoder, value instanceof MultiplexMessage() ? value : THROW_CCE());
      }
      pz(decoder) {
        var tmp0_desc = this.a4q_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = false;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.l13(tmp0_desc);
        var tmp12_cached = Companion_getInstance().j3j_1;
        if (tmp11_input.a14()) {
          tmp4_local0 = tmp11_input.v13(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.n13(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.n13(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.b14(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.v13(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.z13(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.z13(tmp0_desc, 2, tmp12_cached[2].f2(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.n13(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.n13(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.z13(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.z13(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().x10(tmp2_index);
            }
          }
        tmp11_input.m13(tmp0_desc);
        return MultiplexMessage().j4q(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      az() {
        return this.a4q_1;
      }
      t1b() {
        var tmp0_cached = Companion_getInstance().j3j_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[2].f2()), BooleanSerializer_getInstance(), BooleanSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).u1b = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var MultiplexMessageClass;
function MultiplexMessage() {
  if (MultiplexMessageClass === VOID) {
    class $ {
      constructor(channel, path, queryParams, start, end, data, error) {
        Companion_getInstance();
        path = path === VOID ? null : path;
        queryParams = queryParams === VOID ? null : queryParams;
        start = start === VOID ? false : start;
        end = end === VOID ? false : end;
        data = data === VOID ? null : data;
        error = error === VOID ? null : error;
        this.c4q_1 = channel;
        this.d4q_1 = path;
        this.e4q_1 = queryParams;
        this.f4q_1 = start;
        this.g4q_1 = end;
        this.h4q_1 = data;
        this.i4q_1 = error;
      }
      toString() {
        return 'MultiplexMessage(channel=' + this.c4q_1 + ', path=' + this.d4q_1 + ', queryParams=' + toString(this.e4q_1) + ', start=' + this.f4q_1 + ', end=' + this.g4q_1 + ', data=' + this.h4q_1 + ', error=' + this.i4q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.c4q_1);
        result = imul(result, 31) + (this.d4q_1 == null ? 0 : getStringHashCode(this.d4q_1)) | 0;
        result = imul(result, 31) + (this.e4q_1 == null ? 0 : hashCode(this.e4q_1)) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.f4q_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.g4q_1) | 0;
        result = imul(result, 31) + (this.h4q_1 == null ? 0 : getStringHashCode(this.h4q_1)) | 0;
        result = imul(result, 31) + (this.i4q_1 == null ? 0 : getStringHashCode(this.i4q_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MultiplexMessage()))
          return false;
        if (!(this.c4q_1 === other.c4q_1))
          return false;
        if (!(this.d4q_1 == other.d4q_1))
          return false;
        if (!equals(this.e4q_1, other.e4q_1))
          return false;
        if (!(this.f4q_1 === other.f4q_1))
          return false;
        if (!(this.g4q_1 === other.g4q_1))
          return false;
        if (!(this.h4q_1 == other.h4q_1))
          return false;
        if (!(this.i4q_1 == other.i4q_1))
          return false;
        return true;
      }
      static j4q(seen0, channel, path, queryParams, start, end, data, error, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().a4q_1);
        }
        var $this = createThis(this);
        $this.c4q_1 = channel;
        if (0 === (seen0 & 2))
          $this.d4q_1 = null;
        else
          $this.d4q_1 = path;
        if (0 === (seen0 & 4))
          $this.e4q_1 = null;
        else
          $this.e4q_1 = queryParams;
        if (0 === (seen0 & 8))
          $this.f4q_1 = false;
        else
          $this.f4q_1 = start;
        if (0 === (seen0 & 16))
          $this.g4q_1 = false;
        else
          $this.g4q_1 = end;
        if (0 === (seen0 & 32))
          $this.h4q_1 = null;
        else
          $this.h4q_1 = data;
        if (0 === (seen0 & 64))
          $this.i4q_1 = null;
        else
          $this.i4q_1 = error;
        return $this;
      }
    }
    initMetadataForClass($, 'MultiplexMessage', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    MultiplexMessageClass = $;
  }
  return MultiplexMessageClass;
}
//region block: exports
export {
  MultiplexMessage as MultiplexMessage1yepwrh5ltbje,
  Companion_getInstance as Companion_getInstance4nebw1aefgxh,
};
//endregion

//# sourceMappingURL=MultiplexMessage.mjs.map
